export function commercialTaskFields(fields) {
  const result = {}
  for (const [field, value] of Object.entries(fields)) {
    if (field === 'status') result.status = value === 'concluido' ? 'feito' : 'pendente'
    else if (field === 'data_inicio') result.inicio_at = value
    else if (field === 'assignee_ids') result.responsavel_id = value[0] || null
    else if (['titulo','descricao','tipo','prioridade','prazo'].includes(field)) result[field] = value
    else throw new Error('Este campo não pertence à atividade comercial.')
  }
  return result
}
